module.exports = __webpack_public_path__ + "img/measure.f2a3865b.svg";